import {
    ORGANIZATIONS_LIST,
} from "../actions/adminRegistration/actionTypes";


const initialObject = {
    loading: false,
    message: "",
    totalCount: 0,
    isSuccess: false,
    isDuplicateUser: "null",
    organizationList: [],
};

export const adminRegistrationReducer = (state = initialObject, action) => {
    switch (action.type) {
     
        case ORGANIZATIONS_LIST:
           
            console.log("Reducer Payload (Full API Response):", action);
            return {
                ...state,
                loading: false,
                message: action.payload.message,
                organizationList: action.payload.data.data,
                totalCount:action.payload.data.totalCount,
                isSuccess: action.payload.success,
            };

        default:
            return state;
    }
};
